import { render, staticRenderFns } from "./MultiComponent.vue?vue&type=template&id=89df0d9e&"
import script from "./MultiComponent.vue?vue&type=script&lang=ts&"
export * from "./MultiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports